import { useHistory } from 'react-router';

import routes from 'constants/routes';
import { noop } from 'helpers/utils';
import i18n from 'i18n/config';
// import CircularQuestion from 'styles/assets/icons/CircularQuestion';
import HistoryClock from 'styles/assets/icons/HistoryClock';
import Box from 'UIKit/Box';
import IconButton from 'UIKit/IconButton';

import styles from './accountHeaderPartials.module.scss';

const signalTradingText = i18n.t<string>('account:sideNav.signalTrading');

const SignalTradingAccountHeader = () => {
  const history = useHistory();

  return (
    <Box
      flex="flex"
      fullWidth
      gap={16}
      alignItems="center"
      className={styles.signalTradingHeader}
    >
      <Box as="span" autoMargin="both">
        {signalTradingText}
      </Box>
      {/* <IconButton
        onKeyDown={noop}
        icon={<CircularQuestion />}
        onClick={() => history.push(routes.account.signalTradingInfo)}
        data-testid="how-it-works"
      /> */}
      <IconButton
        icon={<HistoryClock height={15} />}
        onClick={() => history.push(routes.account.activeWebhooks)}
        data-testid="how-it-works"
        onKeyDown={noop}
      />
    </Box>
  );
};

export { SignalTradingAccountHeader };
